import React from 'react';

const EmptyState: React.FC = () => {
  return (
    <div className="text-center text-gray-600 mt-10">
      <div className="max-w-md mx-auto">
        <svg
          className="mx-auto h-12 w-12 text-gray-400 mb-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            vectorEffect="non-scaling-stroke"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          />
        </svg>
        <h2 className="text-sm font-medium text-gray-900 mb-2">
          No properties found
        </h2>
        <p className="text-sm text-gray-500">
          No properties found matching your search criteria. Try adjusting your
          filters or search terms.
        </p>
      </div>
    </div>
  );
};

export default EmptyState;
